import { render, staticRenderFns } from "./testswiper.vue?vue&type=template&id=16860cb4&"
import script from "./testswiper.vue?vue&type=script&lang=js&"
export * from "./testswiper.vue?vue&type=script&lang=js&"
import style0 from "./testswiper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports